import {
    RESET_ACCESSORY_ACTION_STATE,
    RESET_ACCESSORY_STATE,
    CREATE_ACCESSORY,
    CREATE_ACCESSORY_SUCCESS,
    CREATE_ACCESSORY_FAIL,
    GET_ACCESSORY_LISTING,
    GET_ACCESSORY_LISTING_SUCCESS,
    GET_ACCESSORY_LISTING_FAIL,
    GET_ACCESSORY_DETAILS,
    GET_ACCESSORY_DETAILS_SUCCESS,
    GET_ACCESSORY_DETAILS_FAIL,
    GET_ACCESSORY_DETAIL_LISTING,
    GET_ACCESSORY_DETAIL_LISTING_SUCCESS,
    GET_ACCESSORY_DETAIL_LISTING_FAIL,
    UPDATE_ACCESSORY,
    UPDATE_ACCESSORY_SUCCESS,
    UPDATE_ACCESSORY_FAIL,
    ADD_REMARK,
    ADD_REMARK_SUCCESS,
    ADD_REMARK_FAIL,
    TOGGLE_FEATURE,
    TOGGLE_FEATURE_SUCCESS,
    TOGGLE_FEATURE_FAIL,
    BULK_ACTION,
    BULK_ACTION_SUCCESS,
    BULK_ACTION_FAIL,
    BULK_DELETE_ACCESSORY,
    BULK_DELETE_ACCESSORY_SUCCESS,
    BULK_DELETE_ACCESSORY_FAIL,
} from "./actionTypes";

export const getAccessoryListing = (data) => ({
    type: GET_ACCESSORY_LISTING,
    payload: data,
});

export const getAccessoryListingSuccess = data => ({
    type: GET_ACCESSORY_LISTING_SUCCESS,
    payload: data,
});

export const getAccessoryListingFail = error => ({
    type: GET_ACCESSORY_LISTING_FAIL,
    payload: error,
});

export const getAccessoryDetails = (data) => ({
    type: GET_ACCESSORY_DETAILS,
    payload: data,
});

export const getAccessoryDetailsSuccess = data => ({
    type: GET_ACCESSORY_DETAILS_SUCCESS,
    payload: data,
});

export const getAccessoryDetailsFail = error => ({
    type: GET_ACCESSORY_DETAILS_FAIL,
    payload: error,
});

export const getAccessoryDetailListing = (data) => ({
    type: GET_ACCESSORY_DETAIL_LISTING,
    payload: data,
});

export const getAccessoryDetailListingSuccess = (data, listingType) => ({
    type: GET_ACCESSORY_DETAIL_LISTING_SUCCESS,
    payload: { data, listingType },
});

export const getAccessoryDetailListingFail = (error, listingType) => ({
    type: GET_ACCESSORY_DETAIL_LISTING_FAIL,
    payload: { error, listingType },
});

export const createAccessory = (data) => ({
    type: CREATE_ACCESSORY,
    payload: data,
});

export const createAccessorySuccess = data => ({
    type: CREATE_ACCESSORY_SUCCESS,
    payload: data,
});

export const createAccessoryFail = error => ({
    type: CREATE_ACCESSORY_FAIL,
    payload: error,
});

export const updateAccessory = (data) => ({
    type: UPDATE_ACCESSORY,
    payload: data,
});

export const updateAccessorySuccess = data => ({
    type: UPDATE_ACCESSORY_SUCCESS,
    payload: data,
});

export const updateAccessoryFail = error => ({
    type: UPDATE_ACCESSORY_FAIL,
    payload: error,
});

export const addRemark = (data) => ({
    type: ADD_REMARK,
    payload: data,
});

export const addRemarkSuccess = data => ({
    type: ADD_REMARK_SUCCESS,
    payload: data,
});

export const addRemarkFail = error => ({
    type: ADD_REMARK_FAIL,
    payload: error,
});

export const toggleFeature = (data) => ({
    type: TOGGLE_FEATURE,
    payload: data,
});

export const toggleFeatureSuccess = data => ({
    type: TOGGLE_FEATURE_SUCCESS,
    payload: data,
});

export const toggleFeatureFail = error => ({
    type: TOGGLE_FEATURE_FAIL,
    payload: error,
});

export const bulkAction = (data) => ({
    type: BULK_ACTION,
    payload: data,
});

export const bulkActionSuccess = data => ({
    type: BULK_ACTION_SUCCESS,
    payload: data,
});

export const bulkActionFail = error => ({
    type: BULK_ACTION_FAIL,
    payload: error,
});

export const bulkDeleteAccessory = (data) => ({
    type: BULK_DELETE_ACCESSORY,
    payload: data,
});

export const bulkDeleteAccessorySuccess = data => ({
    type: BULK_DELETE_ACCESSORY_SUCCESS,
    payload: data,
});

export const bulkDeleteAccessoryFail = error => ({
    type: BULK_DELETE_ACCESSORY_FAIL,
    payload: error,
});

//reset
export const resetAccessoryActionState = () => {
    return {
        type: RESET_ACCESSORY_ACTION_STATE,
    }
}
export const resetAccessoryState = () => {
    return {
        type: RESET_ACCESSORY_STATE,
    }
}

